const Config = {
    // apiBaseUrl: "http://localhost:4444/apis/v1/core/admin",
    // apiCoreBaseUrl: "http://localhost:4444/apis/v1/core",
    // apiDomain: "localhost:4444",
    apiBaseUrl: "https://erratic-api.vrmsoftcom.com/apis/v1/core/admin",
    apiCoreBaseUrl: "https://erratic-api.vrmsoftcom.com/apis/v1/core",
    apiDomain: "erratic-api.vrmsoftcom.com",
};

export default Config;
